///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm = abcsetup.three_pm || {};
abcsetup.three_pm.price_change = abcsetup.three_pm.price_change || {};
abcsetup.three_pm.price_change.edit = abcsetup.three_pm.price_change.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm.price_change.edit = {

    /**
     *
     */
    init: function () {
        abcsetup.setTitle('3PM Price Change');
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        abcsetup.three_pm.price_change.common.bindFormElems();
    },

}
